import { createContext } from "react";

import type { IGenericUploadPhoneConflict } from "../../generic-upload.models";

export interface IGenericUploadPhoneConflictsContext {
  conflicts: IGenericUploadPhoneConflict[];
  skippedDataIndexes: number[];
  onToggleSkippedRow: (dataIndex: number) => void;
}

export const GenericUploadPhoneConflictsContext =
  createContext<IGenericUploadPhoneConflictsContext>({
    conflicts: [],
    skippedDataIndexes: [],
    onToggleSkippedRow: () => undefined,
  });
